export default __webpack_public_path__ + "static/media/MiniSlide-2.61aa82c5.png";